var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBkgPro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 1234,
    viewBox: "0 0 600 1234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_16)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 1234,
    fill: "#15293B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 811V649.803L215.797 245H319V574.556L219.099 811H1ZM30.6581 314.826L31.5845 314.505L30.6581 314.826C42.8915 350.125 46.9397 381.79 42.6213 409.748C38.3056 437.689 25.6256 461.986 4.29759 482.564C3.2156 483.607 2.11641 484.637 1 485.655V253.583C13.2215 272.63 23.1032 293.024 30.6581 314.826Z",
    stroke: "url(#paint0_linear_286_16)",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 881.08L403.491 0H600V718.584L412.054 1234H0V881.08ZM9.35929 519.854C6.3117 523.258 3.19196 526.598 0 529.875V13.49C24.5952 56.772 44.3377 103.279 59.2556 153.16C105.267 306.994 89.9098 429.802 9.35929 519.854Z",
    fill: "url(#paint1_linear_286_16)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_16",
    x1: 182.817,
    y1: 315.544,
    x2: 21.33,
    y2: 531.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.462867,
    stopColor: "#F3F3F3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_286_16",
    x1: 826.156,
    y1: -297.385,
    x2: -617.003,
    y2: 1239.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0492215,
    stopColor: "#5B74AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343092,
    stopColor: "#15293B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505982,
    stopColor: "#213B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781255,
    stopColor: "#693351"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 1234,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgPro);
export default __webpack_public_path__ + "static/media/bkg-pro.21bbdfbe9d38d3440bb7852a0062e621.svg";
export { ForwardRef as ReactComponent };